/**
 * Re-order collection product cards by the selling price shown on each card
 * (data-sort-price). Keeps non-product tiles (e.g. promotions) in place.
 */
export function sortCollectionGridByPrice(root = document) {
  const params = new URLSearchParams(window.location.search);
  const sortBy = params.get("sort_by");
  if (sortBy !== "price-ascending" && sortBy !== "price-descending") return;

  const grid = root.querySelector("#product-grid") || document.getElementById("product-grid");
  if (!grid) return;

  const children = Array.from(grid.children);
  const productItems = children.filter(
    (el) => el.classList?.contains("product-item") && el.dataset?.sortPrice != null && el.dataset.sortPrice !== ""
  );
  if (productItems.length < 2) return;

  const ascending = sortBy === "price-ascending";
  const sorted = productItems.slice().sort((a, b) => {
    const priceA = Number(a.dataset.sortPrice) || 0;
    const priceB = Number(b.dataset.sortPrice) || 0;
    return ascending ? priceA - priceB : priceB - priceA;
  });

  const fragment = document.createDocumentFragment();
  let productIndex = 0;
  children.forEach((child) => {
    if (
      child.classList?.contains("product-item") &&
      child.dataset?.sortPrice != null &&
      child.dataset.sortPrice !== ""
    ) {
      fragment.appendChild(sorted[productIndex++]);
    } else {
      fragment.appendChild(child);
    }
  });
  grid.appendChild(fragment);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => sortCollectionGridByPrice());
} else {
  sortCollectionGridByPrice();
}
